export default {
  zh: {
    affirm: "信息确认",
    companyShareholder: "公司股东信息",
    individual: "个人股东/董事信息",
    individualShareholder: "个人股东",
    agreed: "同意聘用",
    stepTitle01: "确认套餐",
    stepTitle02: "公司取名以及股东信息",
    stepTitle03: "KYC问卷",
    stepTitle04: "公司信息以及股本信息",
    stepTitle05: "资料上传",
    stepTitle06: "服务报价单",
    correlationTitle: "有关其他政府机构的相关批准的申明(单选项，二选一)",
    correlationOption01: "我们理解如果拟设立公司的业务/名称属于某些类别，可能需要获得主管部门的内部批准。 我们已经进行了相关的申请，相关批准文件已上传至本次申请中。",
    correlationOption02:
      "(推荐)我们理解如果拟设立公司的业务/名称属于某些类别，可能需要获得主管部门的内部批准。 若需要审批，我们同意委任{supplierName}进行相关申请，并根据下述服务协议中的费用条款承担此类申请的相应费用，该费用将作为额外费用另行支付。",
    correlationAlready: "我已经阅读服务协议附件",
    correlationCheck: "服务协议",
    engagementLetter: "委托书",
    correlationDownload: "名义董事协议",
    EPApplicationDownload: "EP申请协议",
    userAgreement: "服务协议",
    agreementTitle: "协议签署",
    consentOption01: "同意服务协议",
    consentOption02: "我同意委任{supplierNameAndAbbr}提供上述服务。 提供上述服务的义务将从{supplierAbbr}收到支付的服务费之日起生效。",
    statementOption01: "申请人声明",
    statementOption02: "声明：本人已具备提交本申请的授权，本人填写以上资料全部真实正确，并没有任何隐瞒，如有虚假或隐瞒，本人愿负全部责任。",
    invoiceTitle: "电子发票信息(请输入)",
    invoiceTitle02: "电子发票信息",
    invoiceName: "名称:",
    invoiceAddress: "地址:",
    invoiceCountry: "国家:",
    invoiceCode: "邮编:",
    feeLetter: "收费协议",
  },
  en: {
    affirm: "Confirm",
    companyShareholder: "Information of Corporate Shareholder",
    individual: "Information of Individual Shareholder(s)/Director(s)",
    individualShareholder: "Information of Individual Shareholder",
    agreed: "Nominee Director Service",
    stepTitle01: "Confirmation:",
    stepTitle02: "Company Name",
    stepTitle03: "KYC Questionnaire",
    stepTitle04: "Company Details",
    stepTitle05: "Upload",
    stepTitle06: "Quotation",
    correlationTitle: "Select below choice if approval(s) from specific government authority is required",
    correlationOption01:
      "We understand that in-principal approval might be needed from authority if the business/name of newly incorporated entity falls into certain categaories.  We have applied for related application ourselves, and we have uploaded related in-principal approval documents in this application.",
    correlationOption02:
      "(Recommend) We understand that in-principal approval might be needed from authority if the business/name of newly incorporated entity falls into certain categaories.  We consent to appoint {supplierName} for related application (if applicable), and we will bear corresponding cost for such application which will be charged seperately and based on the fee terms in below service agreement.",
    correlationAlready: "I have read the attached Service Agreement(s)",
    correlationCheck: "Service Agreement",
    engagementLetter: "Engagement Letter",
    correlationDownload: "Nominee Director Agreement",
    EPApplicationDownload: "EP Service Agreement",
    userAgreement: "Service Agreement",
    agreementTitle: "Declaration:",
    consentOption01: "Consent of Service Agreement(s)",
    consentOption02:
      "I consent to appoint {supplierNameAndAbbr} to provide services as mentioned above. The obligation of providing the above mentioned services will be effective from the date when {supplierAbbr} received the payment service fee.",
    statementOption01: "Declaration by applicant:",
    statementOption02:
      "I declare that I have the authorization to submit this application, and the information provided in this application form is true and correct. I am aware that I may be subject to prosecution and criminal sanctions under written law if I am found to have made any false statement which I know to be false or which I do not believe to be true, or if I have intentional suppressed any material fact.",
    invoiceTitle: "Electronic invoice information (please enter)",
    invoiceTitle02: "Electronic invoice information",
    invoiceName: "Name:",
    invoiceAddress: "Address:",
    invoiceCountry: "Country:",
    invoiceCode: "Code:",
    feeLetter: "Fee Letter",
  },
};
